import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";
import OptimizedVideo from "index";

import {
  Container,
  Content,
  ContentProps,
  Illustration,
  Link,
  Message,
  Pitch,
  Tagline,
} from "./HeroWithImageBlock.styles";

export interface HeroWithImageBlockProps
  extends Queries.SanityHeroWithImageBlock {}

const HeroWithImageBlock: React.FC<HeroWithImageBlockProps> = ({
  layoutType,
  tagline,
  headline,
  _rawPitch,
  button,
  image,
  imageAlt,
  video,
  videoAlt,
}) => (
  <Container>
    <Content $layoutType={layoutType as ContentProps["$layoutType"]}>
      <Message $layoutType={layoutType as ContentProps["$layoutType"]}>
        {tagline && <Tagline>{tagline}</Tagline>}
        <Text
          variant="H2"
          as="h1"
          textAlign={
            (layoutType as ContentProps["$layoutType"]) === "image-below"
              ? "center"
              : "left"
          }
        >
          {headline}
        </Text>
        <Pitch $layoutType={layoutType as ContentProps["$layoutType"]}>
          <RichText text={_rawPitch} />
        </Pitch>
        {button?.url && button?.label && (
          <Link href={button?.url}>
            <Button label={button.label} />
          </Link>
        )}
      </Message>

      {(video || image) && (
        <Illustration $layoutType={layoutType as ContentProps["$layoutType"]}>
          {video && (
            <OptimizedVideo
              video={video}
              style={{ maxWidth: "100%", borderRadius: "0.5rem" }}
              alt={videoAlt}
            />
          )}

          {image && !video && <OptimizedImage image={image} alt={imageAlt} />}
        </Illustration>
      )}
    </Content>
  </Container>
);

export const query = graphql`
  fragment HeroWithImageBlock on SanityHeroWithImageBlock {
    _key
    _type
    layoutType
    headline
    _rawPitch(resolveReferences: { maxDepth: 5 })
    tagline
    button {
      variant
      label
      url
    }
    image { ...OptimizedImage }
    imageAlt
    video { ...OptimizedVideo }
    videoAlt
  }
`;

export default HeroWithImageBlock;
